import { Colors, Spacing } from 'cio-design-library/design-tokens'
import styled from 'styled-components'
import Typography, { FontWeights } from 'builder/styles/typography'

export const Container = styled.div`
  position: absolute;
  bottom: 20px;
  right: 20px;
  background: ${Colors.Blue50};
  padding: 20px;
  height: 64px;
  width: 64px;
  border-radius: 50%;
`

export const ToolTip = styled.div`
  position: relative;
  z-index: 2;
  width: 230px;
  left: -103px;
  bottom: 133px;

  white-space: break-spaces;
  text-align: center;
  padding: ${Spacing['2XS']} 12px;
  border-radius: ${Spacing['3XS']} 4px;
  background: ${Colors.Neutral90};
  ${Typography.Caption};
  ${FontWeights.Regular};

  & svg {
    color: ${Colors.White};
  }

  &::after {
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    bottom: -8px;
    left: 50%;
    transform: translateX(-50%);
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-top: 8px solid ${Colors.Neutral90};
  }
`
